module.exports = __webpack_public_path__ + "static/media/respeto.4f4bcb85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/respeto.svg
// module id = 200
// module chunks = 0